import { render, staticRenderFns } from "./PhoneTaskRow.vue?vue&type=template&id=b0872f14&scoped=true"
import script from "./PhoneTaskRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneTaskRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneTaskRow.vue?vue&type=style&index=0&id=b0872f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0872f14",
  null
  
)

export default component.exports